'use no memo';

import { createFileRoute } from '@tanstack/react-router';
import { SECTION_KEYS, SectionFormWrapper, AttributeRenderer, prefetchContractingCorporationProfile, useSaveCorporateProfile, type RenderContentProps } from '../-shared';
export const Route = createFileRoute('/_staff/settings/contracting-corporation-profile/_layout/corporate-overview/')({
  component: CorporateOverview,
  loader: prefetchContractingCorporationProfile
});
function CorporateOverview() {
  return <SectionFormWrapper sectionKey={SECTION_KEYS.CORPORATE_PROFILE} useSaveMutation={useSaveCorporateProfile} renderContent={({
    section
  }: RenderContentProps) => <AttributeRenderer attributes={section.attributes} sectionKey={String(section.sectionKey)} />} />;
}